import type { ReceiptTemplate } from '../schema';

export const cashAppTemplate: ReceiptTemplate = {
  id: 'cash-app',
  name: 'Cash App Receipt',
  brand: 'CASH APP',
  description: 'Cash App payment receipt',
  settings: {
    width: 280,
    font: 'Bit Matrix A',
    fontSize: 12,
    paperStyle: 'thermal',
    backgroundColor: '#ffffff',
    textColor: '#1a1a1a',
    showWatermark: false,
    currency: '$',
    currencyPosition: 'before',
    spacing: 'spaced',
  },
  sections: [
    {
      id: 'ca-header',
      type: 'header',
      enabled: true,
      config: {
        alignment: 'center',
        logoUrl: '/logos/cash-app.png',
        logoData: '',
        logoWidth: 100,
        logoHeight: 40,
        businessName: '',
        businessNameFontSize: 20,
        addressLines: [
          'PAYMENT RECEIPT',
        ],
        showDivider: true,
        dividerStyle: 'solid',
      },
    },
    {
      id: 'ca-trans',
      type: 'two-column',
      enabled: true,
      config: {
        alignment: 'left',
        column1: [
          { id: 'from', label: 'From:', value: '$johndoe' },
          { id: 'to', label: 'To:', value: '$mikewazowski' },
        ],
        column2: [
          { id: 'date', label: 'Date:', value: '01/04/2026' },
          { id: 'time', label: 'Time:', value: '2:45 PM' },
        ],
        showDivider: true,
        dividerStyle: 'dashed',
      },
    },
    {
      id: 'ca-amount',
      type: 'totals',
      enabled: true,
      config: {
        alignment: 'right',
        labelPosition: 30,
        lines: [
          { id: 'amount', label: 'AMOUNT SENT', value: '50.00', isBold: true, isLarge: true },
        ],
        increaseTotalSize: false,
        totalSizeIncrease: 0,
        showDivider: true,
        dividerStyle: 'solid',
      },
    },
    {
      id: 'ca-details',
      type: 'custom-message',
      enabled: true,
      config: {
        alignment: 'left',
        message: 'Note: Dinner split\nTransaction ID: CA847291034567',
        fontSize: 12,
        showDivider: true,
        dividerStyle: 'dashed',
        isBold: false,
      },
    },
    {
      id: 'ca-footer',
      type: 'custom-message',
      enabled: true,
      config: {
        alignment: 'center',
        message: 'PAYMENT COMPLETE\n\nPowered by Cash App',
        fontSize: 12,
        showDivider: false,
        dividerStyle: 'solid',
        isBold: false,
      },
    },
  ],
  updatedAt: new Date().toISOString(),
};

